module.exports = __webpack_public_path__ + "img/20d16ec67900e2293dbee1607169e9f3.png";